import React from "react";
import { ChangeAssigneeOverlay } from "./";

const Assignee = ({
  serviceTicketItem,
  editAssigneeId,
  setEditAssigneeId,
  userState,
}) => {
  return (
    <div className='flex flex-nowrap '>
      {editAssigneeId !== serviceTicketItem._id ? (
        <>
          <div className='peer'>
            {serviceTicketItem.assignee?._id ? (
              <div className='bg-yellow-50  py-1.5 px-2 rounded-sm flex flex-nowrap justify-center gap-2 hover:bg-yellow-50 duration-300'>
                <img
                  src={
                    serviceTicketItem.assignee?.avatar
                      ? serviceTicketItem.assignee?.avatar
                      : "/assets/images/user.png"
                  }
                  alt='avatar'
                  referrerPolicy='no-referrer'
                  className='mt-0.5 h-4 w-4 rounded-full ring-1 ring-yellow-2'
                />
                <div className='flex flex-col justify-center'>
                  <span className='font-semibold text-xs text-yellow-dark whitespace-nowrap'>
                    {serviceTicketItem.assignee?.fullname
                      ? serviceTicketItem.assignee.fullname
                      : serviceTicketItem.assignee.firstname}
                  </span>
                </div>
              </div>
            ) : (
              <div className='bg-gray-200 py-1.5 px-2 rounded-xs flex flex-nowrap justify-center gap-2'>
                <img
                  src={"/assets/images/user.png"}
                  alt='avatar'
                  referrerPolicy='no-referrer'
                  className='mt-0.5 h-4 w-4 rounded-full ring-1 ring-yellow-2'
                />
                <span className='font-semibold text-sm text-gray-100'>
                  UnAssigned
                </span>
              </div>
            )}
          </div>
          {(userState?.department?.name === "CRM" ||
            ["super-admin", "admin", "lead"].includes(
              userState.aclGroup.toLowerCase(),
            )) && (
            <div
              className='ml-2 mt-1 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
              onClick={(e) => {
                setEditAssigneeId(serviceTicketItem._id);
              }}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-5 w-5'
                viewBox='0 0 20 20'
                fill='currentColor'>
                <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
              </svg>
            </div>
          )}
        </>
      ) : (
        <>
          <span className='font-semibold text-sm text-gray-100'>
            Changing Assignee...
          </span>
        </>
      )}
    </div>
  );
};

export default Assignee;
